import React, { useEffect, useState } from 'react'
import Navbar from '../Components/Ui/Navbar'
import Banner from '../Components/Sections/Home/Banner'
import { useParams } from 'react-router-dom'
import ProductsData from '../Data/Products.json'
import ProductDetail from '../Components/Sections/ProductScreen/ProductDetail'
import Formulario from '../Components/Sections/Home/Formulario'
import { Form } from 'antd'
import Footer from '../Components/Ui/Footer'

function Product({id}) {
    
    const [form] = Form.useForm();
    const paramsId = useParams()
    const [product, setProduct] = useState(null)

    useEffect(() => {
        const product = ProductsData.find(product => product.url === paramsId.id)
        if(product){
            setProduct(product)
            form.setFieldsValue({
                product: product.name
            })
        }else{
            window.location.href = '/'
        }
    }, [paramsId])


    if(!product) return <div>Product not found</div>
    


  return (
    <>
    <Navbar />
    <Banner />
    <ProductDetail producto={[product]} />
    <Formulario form={form} />
    <Footer />
    </>
  )
}

export default Product